import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function InvitationAccept() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [info, setInfo] = useState(null);
  const [invalid, setInvalid] = useState(false);
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.invitationLookup(token)
       .then((d) => { setInfo(d); setFirst(d.first_name || ""); setLast(d.last_name || ""); })
       .catch(() => setInvalid(true));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.acceptInvitation({ token, password: pwd, password_confirm: pwd2, first_name: first, last_name: last });
      toast.success("Invito accettato. Ora accedi.");
      nav("/login", { replace: true });
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
    finally { setBusy(false); }
  };

  if (invalid) return (
    <div className="min-h-dvh pxos-gradient-surface grid place-items-center px-4" data-testid="invite-invalid">
      <div className="pxos-card p-8 text-center max-w-md">
        <h1 className="font-display text-xl font-semibold">Invito non valido o scaduto</h1>
        <p className="mt-2 text-sm opacity-70">Contatta l'owner per riceverne uno nuovo.</p>
      </div>
    </div>
  );

  if (!info) return <div className="min-h-dvh grid place-items-center opacity-70">Caricamento…</div>;

  return (
    <div className="min-h-dvh pxos-gradient-surface grid place-items-center px-4" data-testid="invitation-accept-page">
      <div className="w-full max-w-md pxos-card p-8">
        <h1 className="font-display text-2xl font-semibold text-center">Accetta l'invito</h1>
        <p className="mt-1 text-sm text-center opacity-70">Stai creando l'account per <strong>{info.email}</strong></p>
        <form onSubmit={submit} className="mt-6 space-y-3" data-testid="invitation-form">
          <div className="grid grid-cols-2 gap-3">
            <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Nome</span>
              <input required value={first} onChange={(e) => setFirst(e.target.value)} className="pxos-input" data-testid="invite-first" /></label>
            <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Cognome</span>
              <input required value={last} onChange={(e) => setLast(e.target.value)} className="pxos-input" data-testid="invite-last" /></label>
          </div>
          <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Password (min 12)</span>
            <input type="password" required minLength={12} value={pwd} onChange={(e) => setPwd(e.target.value)} className="pxos-input" data-testid="invite-pwd" /></label>
          <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Conferma</span>
            <input type="password" required minLength={12} value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="pxos-input" data-testid="invite-pwd2" /></label>
          <button disabled={busy} className="pxos-btn-primary w-full" data-testid="invitation-submit">Crea account</button>
          <p className="text-xs text-center opacity-70"><Link to="/login" className="underline">Torna al login</Link></p>
        </form>
      </div>
    </div>
  );
}
